<script setup lang="ts">
defineProps<{
  name: 'play' | 'eject' | 'done' | 'pause' | 'queue' | 'confirm' | 'cancel';
}>();
</script>

<template>
  <!-- Resume — filled triangle, optically centered like a media player -->
  <svg
    v-if="name === 'play'"
    class="chamber-icon"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      d="M9.2 6.8a1 1 0 0 1 1.55-.83l7.8 4.7a1 1 0 0 1 0 1.66l-7.8 4.7A1 1 0 0 1 9.2 17.2V6.8z"
      fill="currentColor"
    />
  </svg>

  <!-- Eject — cartridge up from slot -->
  <svg
    v-else-if="name === 'eject'"
    class="chamber-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M12 6.5 7.5 13h9L12 6.5z" />
    <path d="M7 16.5h10" />
  </svg>

  <!-- Done -->
  <svg
    v-else-if="name === 'done'"
    class="chamber-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <circle
      cx="12"
      cy="12"
      r="9"
    />
    <path d="m8.2 12.2 2.2 2.2 5.2-5.4" />
  </svg>

  <!-- Pause -->
  <svg
    v-else-if="name === 'pause'"
    class="chamber-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
    aria-hidden="true"
  >
    <line
      x1="9"
      y1="7"
      x2="9"
      y2="17"
    />
    <line
      x1="15"
      y1="7"
      x2="15"
      y2="17"
    />
  </svg>

  <!-- Queue / my stuff -->
  <svg
    v-else-if="name === 'queue'"
    class="chamber-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
    aria-hidden="true"
  >
    <line
      x1="6"
      y1="7"
      x2="18"
      y2="7"
    />
    <line
      x1="6"
      y1="12"
      x2="18"
      y2="12"
    />
    <line
      x1="6"
      y1="17"
      x2="13"
      y2="17"
    />
  </svg>

  <svg
    v-else-if="name === 'confirm'"
    class="chamber-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="m5 12.5 4 4L19 6.5" />
  </svg>

  <svg
    v-else-if="name === 'cancel'"
    class="chamber-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
    aria-hidden="true"
  >
    <line
      x1="7"
      y1="7"
      x2="17"
      y2="17"
    />
    <line
      x1="17"
      y1="7"
      x2="7"
      y2="17"
    />
  </svg>
</template>

<style scoped>
.chamber-icon {
  display: block;
  width: 17px;
  height: 17px;
}
</style>
